var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconAdv4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.818115V32.9358C0.5 35.4434 2.58596 37.524 5.1 37.524H20.2521C20.4897 38.1941 20.9294 38.7745 21.511 39.1853C22.0926 39.596 22.7874 39.8171 23.5 39.8181C24.2126 39.8171 24.9074 39.596 25.489 39.1853C26.0706 38.7745 26.5103 38.1941 26.7479 37.524H41.9C44.414 37.524 46.5 35.4434 46.5 32.9358V0.818115H30.4C27.6148 0.818115 25.1918 2.14009 23.5 4.11143C21.8082 2.14009 19.3852 0.818115 16.6 0.818115H0.5ZM5.1 5.40635H16.6C19.1683 5.40635 21.2 7.43282 21.2 9.99459H25.8C25.8 7.43282 27.8317 5.40635 30.4 5.40635H41.9V32.9358H5.1V5.40635ZM30.4 12.2887V16.8769H35V12.2887H30.4ZM30.4 19.1711V28.3475H35V19.1711H30.4Z",
    fill: "#646AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconAdv4);
export default __webpack_public_path__ + "static/media/management-icon-adv-4.25b465bb8afc3cb6589b807df745421d.svg";
export { ForwardRef as ReactComponent };